<template>
  <v-dialog persistent v-model="get_dialogMain.dialog" :width="get_dialogMain.withWindows" justify-center>
    <v-toolbar dense dark color="blue darken-2">
      <v-btn v-if="showReturnForm" class="hidden-xs-only" @click="ReturnForm()" icon>
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title> <h3>{{ get_dialogMain.title }}</h3></v-toolbar-title>
      <v-spacer/>
      <v-btn icon dark @click="HIDDE_DIALOG_MAIN()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card tile>
      <v-card-text>
        <v-row dense class="pt-4">
          <v-col cols="12" v-if="showSelectedFamily">
            <SelectedGroupMain :setterModel="selectedFamilia" :itemAction="family" :on-success="selectFamilia" />
          </v-col>
          <v-col cols="12">
            <MainGeneralForm v-if="showFormSecound"
              :form="formSecound" :model="objectSecound" :on-success="save" :on-cancel="cancel" />
            <MainProcessForm v-else-if="showFormMain && formMain.status_finish"
              :form="formMain" :model="objectMain" :on-success="saveProcess" :on-cancel="cancel" />
          </v-col>
        </v-row>

      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import MainGeneralForm from '@/components/forms/main/MainGeneralForm'
import MainProcessForm from '@/components/forms/main/MainProcessForm'
import SelectedGroupMain from '@/components/fields/selectedGroupMain'
export default {
  props: ['model', 'params'],
  data: () => ({
    showReturnForm: false,
    idMain: 0,

    showFormMain: false,
    formMain: {},
    objectMain: {},

    showFormSecound: false,
    formSecound: {},
    objectSecound: {},

    showSelectedFamily: false,
    selectedFamilia: 0,
    fields: {},
    family: {
      field: 'selectGroupDataServer',
      name: 'Familia-SubFamilia',
      nameid: 'familiaId',
      url: '/familias/subfamilias',
      cols: 6,
      showFamilia: false
    }
  }),
  components: {
    MainGeneralForm,
    MainProcessForm,
    SelectedGroupMain
  },
  mounted () {
    if (this.params.form) {
      this.formSecound = this.params.form
      this.objectSecound = Object.assign({}, this.model)
      this.showFormSecound = true
    } else if (this.get_dialogMain.form === 'process') {
      if (this.params.updated) {
        if (this.params.family) {
          this.objectSecound = this.model.caracteristicas
          this.objectMain = this.model.descripcion
          this.selectedFamilia = this.model.descripcion.familia_id
          this.showSelectedFamily = true
          this.idMain = this.model.id
        }
        this.getFormServicesAction({ url: this.params.urloption, params: `/${this.params.process}` })
        return
      }
      if (this.params.family) this.showSelectedFamily = true
      else this.showFormMain = true
      if (this.params.setmodel) this.objectMain = this.model
      if (this.model.action) {
        if (this.model.item.id) {
          this.idMain = this.model.item.id
        }
        this.formMain = this.model.body
        return
      }
      this.getFormServicesAction({ url: this.params.urloption, params: `/${this.params.process}` })
    }
  },
  methods: {
    ...mapActions(['urlPostServicesAction', 'getFormServicesAction', 'urlGetServiceActionTwo', 'postExecuteAction']),
    ...mapMutations(['HIDDE_DIALOG_MAIN', 'CLEAR_DATA', 'SET_DATA_OBJECT', 'CLEAR_OBJECTS_MODEL']),
    selectFamilia (familia) {
      if (familia) {
        this.selectedFamilia = familia.data
        this.findFamily(familia.data)
      }
    },
    findFamily (familyId) {
      const router = this.get_urls['familias.caracteristica']
      this.urlGetServiceActionTwo({ url: router, params: `/${familyId}`, replace: '/{id}' })
    },
    ReturnForm () {
      this.showReturnForm = false
      this.showSelectedFamily = true
      this.showFormMain = false
      this.showFormSecound = true
    },
    save (model) {
      if (this.params.family) {
        this.objectSecound = model
        this.showReturnForm = true
        this.showSelectedFamily = false
        this.showFormSecound = false
        this.showFormMain = true
        return
      }
      this.urlPostServicesAction({ url: this.params.url, data: model })
    },
    saveProcess (model) {
      if (this.params.family) {
        model.descripcion.familia_id = this.selectedFamilia
        model.caracteristica = this.objectSecound
      }
      if (this.idMain > 0) model.id = this.idMain
      if (this.params.updated) {
        model.action = 'toUpdate'
      }

      model.tipo_proceso_id = this.params.process
      // console.log('model', model)
      this.postExecuteAction({ url: this.params.urlprocess, data: model })
    },
    cancel () {
      this.HIDDE_DIALOG_MAIN()
    }
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_object', 'get_objectTwo', 'get_options', 'get_model'])
  },
  watch: {
    get_object (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitoso!',
        text: this.message
      })
      if (this.get_dialogMain.body && this.get_dialogMain.body.content === 'form-data') {
        this.cancel()
        return
      }
      this.SET_DATA_OBJECT(val)
      this.cancel()
    },
    get_objectTwo (vals) {
      if (vals) {
        this.formSecound = vals.fields
        this.showFormSecound = true
      }
    },
    get_options (val) {
      this.formMain = val
    },
    get_model (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error !',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'succes',
        icon: 'success',
        title: 'Exitoso!',
        text: this.params.message,
        timer: 1500
      })
      this.SET_DATA_OBJECT(val)
      this.cancel()
    }
  },
  beforeDestroy () {
    this.CLEAR_OBJECTS_MODEL()
  }
}
</script>

<style></style>
